/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AddItemMovementModal_item$ref = any;
export type ItemTransactionType = "ADD" | "DEDUCT" | "PURCHASE_RECEIPT" | "TRANSFER";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ItemTransactionLog_item$ref: FragmentReference;
declare export opaque type ItemTransactionLog_item$fragmentType: ItemTransactionLog_item$ref;
export type ItemTransactionLog_item = {|
  +id: string,
  +itemNumber: string,
  +quantityUOM: {|
    +id: string,
    +name: string,
  |},
  +logs: $ReadOnlyArray<{|
    +id: string,
    +user: {|
      +id: string
    |},
    +lot: {|
      +id: string,
      +lotNumber: string,
      +binNumber: ?string,
      +expiresAt: ?any,
    |},
    +fromLot: ?{|
      +id: string,
      +lotNumber: string,
      +binNumber: ?string,
      +expiresAt: ?any,
    |},
    +operation: ItemTransactionType,
    +quantity: number,
    +createdAt: any,
    +notes: ?string,
  |}>,
  +lots: {|
    +edges: ?$ReadOnlyArray<?{|
      +quantity: ?number,
      +node: {|
        +id: string,
        +lotNumber: string,
      |},
    |}>
  |},
  +lotTracking: ?boolean,
  +$fragmentRefs: AddItemMovementModal_item$ref,
  +$refType: ItemTransactionLog_item$ref,
|};
export type ItemTransactionLog_item$data = ItemTransactionLog_item;
export type ItemTransactionLog_item$key = {
  +$data?: ItemTransactionLog_item$data,
  +$fragmentRefs: ItemTransactionLog_item$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lotNumber",
  "args": null,
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "binNumber",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "expiresAt",
    "args": null,
    "storageKey": null
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ItemTransactionLog_item",
  "type": "Item",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "lots"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "itemNumber",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "quantityUOM",
      "storageKey": null,
      "args": null,
      "concreteType": "UOM",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "logs",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemTransactionLog",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "lot",
          "storageKey": null,
          "args": null,
          "concreteType": "Lot",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "fromLot",
          "storageKey": null,
          "args": null,
          "concreteType": "Lot",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "operation",
          "args": null,
          "storageKey": null
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "createdAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "lots",
      "name": "__Item_lots_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemLotConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemLotEdge",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Lot",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lotTracking",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AddItemMovementModal_item",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fb5961b0b2fd79f08e6296672d8ab685';
module.exports = node;
